<template>
  <div>
    <AppNewHeader
      :userName="userName"
      style="width: 100%"
      :placeholderText="'搜索知识资源'"
    />
    <div class="dljg_banner">
      <h1>
        <img :src="dljg" alt="" />
      </h1>
    </div>
    <div class="wrap">
      <div class="branch-office">
        <h5 class="module-title">
          <b>全国各区域销售订购咨询</b>
          <span
            >（如您单位需要采购亿知知识库内容，可联系以下区域销售进行订购咨询）</span
          >
        </h5>
        <div class="office-nav clearfix">
          <div class="nav-item nav-item-first w1">
            <div class="nav-item-title">
              <i>East</i>
              <span>华东地区</span>
            </div>
            <ul>
              <li data-href="#10">上海</li>
              <li data-href="#12" @click="checkProvince">江苏</li>
              <li data-href="#11">浙江</li>
              <li data-href="#12" @click="checkProvince">安徽</li>
              <li data-href="#13">江西</li>
              <li data-href="#8">山东</li>
              <li data-href="#16">福建</li>
            </ul>
          </div>
          <div class="nav-item w3">
            <div class="nav-item-title"><i>West</i><span>西北西南</span></div>
            <ul>
              <li data-href="#19">四川</li>
              <li data-href="#24">宁夏</li>
              <li data-href="#19">西藏</li>
              <li data-href="#23">陕西</li>
              <li data-href="#20">重庆</li>
              <li data-href="#25">新疆</li>
              <li data-href="#24">甘肃</li>
              <li data-href="#21">云南</li>
              <li data-href="#24">青海</li>
              <li data-href="#22">贵州</li>
            </ul>
          </div>
          <div class="nav-item w1">
            <div class="nav-item-title"><i>South</i><span>华南地区</span></div>
            <ul>
              <li data-href="#17">广东</li>
              <li data-href="#18">广西</li>
              <li data-href="#18">海南</li>
            </ul>
          </div>
          <div class="nav-item w2">
            <div class="nav-item-title"><i>North</i><span>华北东北</span></div>
            <ul>
              <li data-href="#">北京</li>
              <li data-href="#12" @click="checkProvince">天津</li>
              <li data-href="#26">山西</li>
              <li data-href="#6">河北</li>
              <li data-href="#3">辽宁</li>
              <li data-href="#5">内蒙古</li>
              <li data-href="#2">吉林</li>
              <li data-href="#1">黑龙江</li>
            </ul>
          </div>
          <div class="nav-item w3">
            <div class="nav-item-title">
              <i>Central</i><span>华中地区</span>
            </div>
            <ul>
              <li data-href="#7">河南</li>
              <li data-href="#12" @click="checkProvince">湖北</li>
              <li data-href="#15">湖南</li>
            </ul>
          </div>
        </div>
        <ul class="office-list clearfix">
          <!-- <li data-id="">
                <div class="item">
                    <div class="tag"><i>京</i></div>
                    <h6></h6>
                    <p><b>地址：</b></p>
                    <p><b>电话：</b></p>
                    <p><b>邮箱：</b></p>
                </div>
            </li> -->

          <!-- <li data-id="10">
                <div class="item">
                    <div class="tag"><i>沪</i></div>
                    <h6>同方知网（北京）技术有限公司 上海分公司</h6>
                    <p><b>地址：</b>上海市徐汇区桂平路391号3号楼1506室</p>
                    <p><b>电话：</b>021-64689980</p>
                    <p><b>邮箱：</b>shanghai-market@cnki.net</p>
                </div>
            </li>
            <li data-id="9">
                <div class="item">
                    <div class="tag"><i>苏</i></div>
                    <h6>同方知网（北京）技术有限公司 江苏分公司</h6>
                    <p><b>地址：</b>南京市江宁区胜利路89号紫金研发创业中心4号楼702B</p>
                    <p><b>电话：</b>025-52114483，025-52114521</p>
                    <p><b>邮箱：</b>jiangsu-market@cnki.net</p>
                </div>
            </li>
            <li data-id="11">
                <div class="item">
                    <div class="tag"><i>浙</i></div>
                    <h6>同方知网（北京）技术有限公司 杭州分公司</h6>
                    <p><b>地址：</b>浙江省杭州市钱塘区白杨街道新加坡科技园1幢2层201-206室</p>
                    <p><b>电话：</b>0571-86583210</p>
                    <p><b>邮箱：</b>zhejiang@cnki.net</p>
                </div>
            </li> -->
          <li data-id="12">
            <div class="item">
              <div class="tag"><i>津</i><i>皖</i><i>苏</i><i>鄂</i></div>
              <h6>天津艾莱博锐信息科技有限公司</h6>
              <p><b>地址：</b>天津市武清区黄庄街道泉里路1号智库大厦7169室</p>
              <p><b>电话：</b>13581818650</p>
              <p><b>邮箱：</b></p>
            </div>
          </li>
          <!-- <li data-id="13">
                <div class="item">
                    <div class="tag"><i>赣</i></div>
                    <h6>同方知网（北京）技术有限公司 江西分公司</h6>
                    <p><b>地址：</b>江西省南昌市贤士一路4号核工业江西矿冶局办公楼二楼中国知网</p>
                    <p><b>电话：</b>0791-88698061</p>
                    <p><b>邮箱：</b>lh14395@cnki.net</p>
                </div>
            </li> -->
          <li data-id="19" class="">
            <div class="item">
              <div class="tag"><i>川</i><i>藏</i></div>
              <h6>西安优看电子科技有限公司</h6>
              <p><b>地址：</b>陕西省西安市高新区唐延路41号通达国际大厦905室</p>
              <p><b>电话：</b>029-68813768</p>
              <p><b>邮箱：</b></p>
            </div>
          </li>
          <!-- <li data-id="20">
                <div class="item">
                    <div class="tag"><i>渝</i></div>
                    <h6>重庆同方知网科技发展有限公司</h6>
                    <p><b>地址：</b>重庆市渝北区龙溪街道红锦大道90号中渝广场2幢1007，重庆市渝北区仙桃数据谷中路107号</p>
                    <p><b>电话：</b>023-63248271</p>
                    <p><b>邮箱：</b>cqtfzw@cnki.net</p>
                </div>
            </li> -->
          <li data-id="24" class="">
            <div class="item">
              <div class="tag"><i>甘</i><i>青</i><i>宁</i></div>
              <h6>西安优看电子科技有限公司</h6>
              <p><b>地址：</b>陕西省西安市高新区唐延路41号通达国际大厦905室</p>
              <p><b>电话：</b>029-68813768</p>
              <p><b>邮箱：</b></p>
            </div>
          </li>
          <li data-id="23">
            <div class="item">
              <div class="tag"><i>陕</i></div>
              <h6>陕西亿知信息科技有限公司</h6>
              <p><b>地址：</b>陕西省西安市高新区锦业一路中投国际B座1507室</p>
              <p><b>电话：</b>029-85563046</p>
              <p><b>邮箱：</b></p>
            </div>
          </li>
          <!-- <li data-id="25" class="">
                <div class="item">
                    <div class="tag"><i>新</i></div>
                    <h6>同方知网（北京）技术有限公司 新疆分公司</h6>
                    <p><b>地址：</b>乌鲁木齐经济技术开发区喀纳斯湖北路455号创智大厦B座18层1805-1808室</p>
                    <p><b>电话：</b>0991-3758257</p>
                    <p><b>邮箱：</b>jsj5689@cnki.net</p>
                </div>
            </li>
            <li data-id="21">
                <div class="item">
                    <div class="tag"><i>云</i></div>
                    <h6>同方知网（北京）技术有限公司 云南分公司</h6>
                    <p><b>地址：</b>云南省昆明市五华区南屏街88号世纪中心33楼</p>
                    <p><b>电话：</b>0871-63639907</p>
                    <p><b>邮箱：</b>yunnan-market@cnki.net</p>
                </div>
            </li>
            <li data-id="22">
                <div class="item">
                    <div class="tag"><i>贵</i></div>
                    <h6>贵州同方知网科技发展有限公司</h6>
                    <p><b>地址：</b>贵州省贵阳市贵阳国家高新技术产业开发区毕节路58号联合广场1栋23层7-8号</p>
                    <p><b>电话：</b>0851-88417619</p>
                    <p><b>邮箱：</b>gztfzw@cnki.net</p>
                </div>
            </li>
            <li data-id="17">
                <div class="item">
                    <div class="tag"><i>粤</i></div>
                    <h6>同方知网（北京）技术有限公司 深圳分公司</h6>
                    <p><b>地址：</b>深圳市福田区福田街道福安社区民田路178号华融大厦2211</p>
                    <p><b>电话：</b>0755-88300010</p>
                    <p><b>邮箱：</b>alison.zhao@int.cnki.net</p>
                </div>
            </li>
            <li data-id="18">
                <div class="item">
                    <div class="tag"><i>桂</i><i>琼</i></div>
                    <h6>同方知网（北京）技术有限公司 广西分公司（广西、海南）</h6>
                    <p><b>地址：</b>南宁市青秀区金浦路33号北部湾国际港务大厦17楼1710、1711、1712、1713号</p>
                    <p><b>电话：</b>0771-5875635</p>
                    <p><b>邮箱：</b>gd_market@cnki.net</p>
                </div>
            </li>
            <li data-id="15">
                <div class="item">
                    <div class="tag"><i>湘</i></div>
                    <h6>同方知网（北京）技术有限公司 湖南分公司</h6>
                    <p><b>地址：</b>长沙市岳麓区金星中路319号金谷大厦201</p>
                    <p><b>电话：</b>0731-85111801</p>
                    <p><b>邮箱：</b>hunan-market@cnki.net</p>
                </div>
            </li>
            <li data-id="16">
                <div class="item">
                    <div class="tag"><i>闽</i></div>
                    <h6>同方知网（北京）技术有限公司 福建分公司</h6>
                    <p><b>地址：</b>福建省福州市闽侯县上街镇科技东路12、16、18号华建大厦2#701室</p>
                    <p><b>电话：</b>0591-83353353</p>
                    <p><b>邮箱：</b>fujian@cnki.net</p>
                </div>
            </li>
            <li data-id="3">
                <div class="item">
                    <div class="tag"><i>辽</i></div>
                    <h6>同方知网（北京）技术有限公司 辽宁分公司</h6>
                    <p><b>地址：</b>辽宁省沈阳市沈河区友好街10号12层（电梯楼层15层）02B+03单元</p>
                    <p><b>电话：</b>024-22559321</p>
                    <p><b>邮箱：</b>zwlnfgs@cnki.net</p>
                </div>
            </li>
            <li data-id="2">
                <div class="item">
                    <div class="tag"><i>吉</i></div>
                    <h6>同方知网（北京）技术有限公司 吉林省分公司</h6>
                    <p><b>地址：</b>吉林省长春市南关区南环城路1088号绿地中央广场B8A2219-2222室</p>
                    <p><b>电话：</b>0431-81961366</p>
                    <p><b>邮箱：</b>zwjlfgs@cnki.net</p>
                </div>
            </li>
            <li data-id="1">
                <div class="item">
                    <div class="tag"><i>黑</i></div>
                    <h6>同方知网（北京）技术有限公司 黑龙江分公司</h6>
                    <p><b>地址：</b>哈尔滨高新技术产业开发区科技创新城创新创业广场18号楼（创新一路789号）E412室</p>
                    <p><b>电话：</b>0451-51905831</p>
                    <p><b>邮箱：</b>longjiangcnki@163.com</p>
                </div>
            </li>
            <li data-id="5">
                <div class="item">
                    <div class="tag"><i>蒙</i></div>
                    <h6>同方知网（北京）技术有限公司 内蒙古分公司</h6>
                    <p><b>地址：</b>内蒙古自治区呼和浩特市新城区海拉尔东街东方银座A座4层</p>
                    <p><b>电话：</b>0471-3468557</p>
                    <p><b>邮箱：</b>neimenggu-market@cnki.net</p>
                </div>
            </li>
            <li data-id="8">
                <div class="item">
                    <div class="tag"><i>鲁</i></div>
                    <h6>同方知网（北京）技术有限公司 山东分公司</h6>
                    <p><b>地址：</b>济南市历下区山大路157号A幢21层2109、2110室</p>
                    <p><b>电话：</b>0531-66229090</p>
                    <p><b>邮箱：</b>zwx7903@cnki.net</p>
                </div>
            </li>
            <li data-id="7">
                <div class="item">
                    <div class="tag"><i>豫</i></div>
                    <h6>同方知网（北京）技术有限公司 河南分公司</h6>
                    <p><b>地址：</b>郑州市中原区沁河路北文化宫路东啟福铭都6号楼18层</p>
                    <p><b>电话：</b>0371-55395703</p>
                    <p><b>邮箱：</b>hnfgs@cnki.net</p>
                </div>
            </li> -->
          <!-- <li data-id="14">
                <div class="item">
                    <div class="tag"><i>鄂</i></div>
                    <h6>天津艾莱博锐信息科技有限公司</h6>
                    <p><b>地址：</b>天津市武清区黄庄街道泉里路1号智库大厦7169室</p>
                    <p><b>电话：</b>15122375338</p>
                    <p><b>邮箱：</b></p>
                </div>
            </li> -->
          <!-- <li data-id="6">
                <div class="item">
                    <div class="tag"><i>冀</i></div>
                    <h6>同方知网（北京）技术有限公司 河北分公司</h6>
                    <p><b>地址：</b>河北省石家庄市裕华区槐安东路105号怀特商业广场写字楼B座1102室</p>
                    <p><b>电话：</b>0311-68053225</p>
                    <p><b>邮箱：</b>hebei@cnki.net</p>
                </div>
            </li> -->
          <!-- <li data-id="4">
                <div class="item">
                    <div class="tag"><i>津</i></div>
                    <h6>天津艾莱博锐信息科技有限公司</h6>
                    <p><b>地址：</b>天津市武清区黄庄街道泉里路1号智库大厦7169室</p>
                    <p><b>电话：</b>15122375338</p>
                    <p><b>邮箱：</b></p>
                </div>
            </li> -->
          <!-- <li data-id="26">
                <div class="item">
                    <div class="tag"><i>晋</i></div>
                    <h6>山西同方知网数字出版产业园管理有限公司</h6>
                    <p><b>地址：</b>山西转型综合改革示范区学府产业园龙城大街58号中国知网数字出版产业基地C座601、C座负一层</p>
                    <p><b>电话：</b>15536039698</p>
                    <p><b>邮箱：</b>xwysx7432@cnki.net</p>
                </div>
            </li> -->
        </ul>
      </div>
    </div>

    <el-footer>
      <div>
        <AppFooter />
      </div>
    </el-footer>
  </div>
</template>

<script setup>
import AppFooter from "@/views/components/AppFooter.vue";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import dljg from "@/assets/image/dljgText.png";
import { ref, onMounted, onUnmounted } from "vue";
import { Cookie } from "@/utils/Cookie";
import { getBuyLog } from "@/api/index.js";
import { usePageStayTime } from "@/utils/usePageStayTime";

const { stayTime, totalStayTimes } = usePageStayTime();
const weburl = ref(window.location.href)
const checkProvince = (event) => {
  var _timer = null;
  var num = event.target.dataset.href.replace("#", "");
  var liList = document.getElementsByClassName("office-list")[0].childNodes;
  var currentNode = null;
  for (var index in liList) {
    // console.log(liList[index])
    // console.log(liList[index].dataset)
    // console.log(liList[index].dataset.id)
    if (liList[index].tagName == "LI") {
      if (
        liList[index].dataset != undefined &&
        num == Number(liList[index].dataset.id)
      ) {
        console.log(liList[index].offsetTop);
        currentNode = liList[index];
        var top = liList[index].offsetTop;
        window.scrollTo({
          top: top,
          behavior: "smooth",
        });
        liList[index].classList.add("active");
        console.log(liList[index].classList);
        _timer = setTimeout(function () {
          currentNode.classList.remove("active");
        }, 4000);
      }
    }
  }
};

const userName = ref("");
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get("userInfo")) || null;
    const user = userString || null;
        userName.value = user?.realName;;
  }
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false; // 如果没有exp字段，则认为永不过期
  } catch (e) {
    return true; // 解析失败视为过期
  }
};
const handleLog = async () => {
  try {
    const res = await getBuyLog({
      type: "4",
       url: weburl.value,
      second: stayTime._value,
    });
    if (res) {
    }
  } catch (error) {
    console.log(error);
  }
};

const hiddenTime = ref(Number);

window.addEventListener("load", async () => {
  // console.log('页面被刷新了',timestamp.value);
  const stored = localStorage.getItem("lastSelectTime");
  // console.log('当前时间戳：',Date.now());
  // const timestamp2 = ref(Number(sessionStorage.getItem('timestamp')))
  hiddenTime.value = Math.floor((Date.now() - stored) / 1000);
  try {
    const res = await getBuyLog({
      type: "4",
      url: weburl.value,
      second: hiddenTime.value,
    });
    if (res.status == 200) {
      localStorage.removeItem("lastSelectTime");
      localStorage.setItem("lastSelectTime", Date.now().toString());
    }
  } catch (error) {
    console.log(error);
  }
});

onMounted(async () => {
  await checkTokenStatus();
});
onUnmounted(async () => {
  await handleLog();
});
</script>
<style scoped>
.el-footer {
  --el-footer-padding: 0;
  --el-footer-height: 0;
  box-sizing: border-box;
  flex-shrink: 0;
  height: var(--el-footer-height);
  padding: var(--el-footer-padding);
}

.dljg_banner {
  background: url(../../assets/newimages/dlijg.png) no-repeat top center #3040d1;
  height: 200px;
  background-size: cover;
  background-repeat: no-repeat;
}
.dljg_banner h1 {
  font-size: 38px;
  font-weight: bold;
  line-height: 59px;
  color: #fdfdfd;
  letter-spacing: 4px;
  text-align: center;
  align-items: center;
  padding-top: 66px;
  width: 507px;
  height: 59px;
  padding-left: 500px;
}
.dljg_banner h1 img {
  width: 507px;
  height: 59px;
}
.wrap {
  width: 1400px;
  margin: 0 auto;
}
.branch-office {
  padding-bottom: 10px;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
}
.module-title {
  padding-top: 15px;
  padding-left: 10px;
  margin-bottom: 30px;
  line-height: 60px;
}
.module-title b {
  display: inline-block;
  vertical-align: middle;
  font-size: 30px;
  font-weight: bold;
  color: #333;
  border-radius: 5px;
}
.module-title span {
  float: right;
  font-size: 16px;
  font-weight: normal;
  color: #666;
}
.office-nav {
  width: 100%;
  max-width: 1380px;
  min-width: 1380px;
  margin: 0 auto 20px;
  background: linear-gradient(180deg, #e0edff, #f5f8fc);
  border-radius: 5px;
}
.office-nav .w1 {
  width: 20%;
}
.office-nav .w2 {
  width: 20%;
}
.office-nav .w3 {
  width: 20%;
}
.clearfix {
  clear: both;
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  font-size: 0;
  visibility: hidden;
  line-height: 0;
}
.office-nav .nav-item {
  position: relative;
  float: left;
  height: 318px;
  padding-left: 90px;
  line-height: 28px;
  text-align: left;
}
.office-nav .nav-item-title {
  position: absolute;
  top: -2px;
  left: 40px;
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 215px;
  padding-top: 70px;
  text-align: center;
  background: linear-gradient(0deg, #3040d1, #3263e4);
  border-radius: 0px 0px 20px 20px;
}
.office-nav .nav-item-title i {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  font-family: "Times New Roman", Times, serif;
  font-weight: normal;
  font-size: 36px;
  color: rgba(72, 176, 255, 0.5);
  line-height: 40px;
  transform: rotate(90deg);
}
.office-nav .nav-item-title span {
  position: relative;
  z-index: 2;
  font-weight: bold;
  font-size: 26px;
  color: #fff;
  line-height: 32px;
}
.office-nav .nav-item ul {
  padding-top: 70px;
  padding-left: 20px;
}
.office-nav li {
  display: inline-block;
  vertical-align: middle;
  width: 70px;
  font-weight: bold;
  font-size: 20px;
  color: #333;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.office-nav .nav-item::before {
  position: absolute;
  bottom: 0;
  left: 0;
  content: "";
  height: 246px;
  width: 3px;
  background-color: #e2eeff;
}
.office-nav .nav-item:first-child::before {
  width: 0px;
}
.office-list li {
  float: left;
  width: 25%;
  margin-bottom: 36px;
  list-style: none;
}
.office-list li .item {
  width: 330px;
  height: 326px;
  padding: 25px 20px 0;
  margin: 0 auto;
  border: 2px solid #fff;
  border-radius: 5px;
  background-color: #f5f8fc;
  transition: all 0.5s;
}
.office-list li .tag {
  height: 44px;
  margin-bottom: 25px;
}
.office-list li i {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 44px;
  margin-right: 10px;
  font-size: 24px;
  font-weight: 400;
  line-height: 44px;
  text-align: center;
  color: #333;
  background: url(../../assets/image/contactus_icons.png);
  overflow: hidden;
  font-style: normal;
}
.office-list li h6 {
  height: 80px;
  font-size: 17px;
  font-weight: 400;
  line-height: 24px;
  color: #333;
}
.office-list li p {
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: #999;
}
.office-list li b {
  font-weight: normal;
  color: #333;
}
.office-list li.active .item {
  border-color: #3040d1;
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
}
</style>
